import { auth } from '../firebase';

import { API_BASE_URL } from '../config/api';

export interface Message {
  id: string;
  conversationId?: string;
  senderId: string;
  receiverId: string;
  content: string;
  timestamp: string;
  isRead: boolean;
  senderName: string;
  receiverName: string;
  /** Mesajla gönderilen dosyanın indirme URL'i (Firebase Storage) */
  attachmentUrl?: string;
  /** Dosya adı (görüntüleme/indirme için) */
  attachmentFileName?: string;
}

export interface Conversation {
  id: string;
  dietitianId: string;
  clientId: string;
  dietitianName: string;
  clientName: string;
  lastMessageTime: string;
  lastMessage: string;
  unreadCount: number;
  isActiveClient?: boolean; // Diyetisyenin aktif danışanı mı?
}

const getAuthToken = async (): Promise<string> => {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Kullanıcı giriş yapmamış');
  }
  return await user.getIdToken();
};

export const messageApi = {
  sendMessage: async (
    message: Omit<Message, 'id' | 'timestamp' | 'isRead'>
  ): Promise<{ messageId: string; success: boolean }> => {
    try {
      const token = await getAuthToken();
      const response = await fetch(`${API_BASE_URL}/messages/send`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(message),
      });

      if (!response.ok) {
        throw new Error('Mesaj gönderilemedi');
      }

      return await response.json();
    } catch (error) {
      console.error('Mesaj gönderme hatası:', error);
      throw error;
    }
  },

  getMessages: async (
    senderId: string,
    receiverId: string
  ): Promise<Message[]> => {
    try {
      const token = await getAuthToken();
      const response = await fetch(
        `${API_BASE_URL}/messages/conversation/${senderId}/${receiverId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error('Mesajlar alınamadı');
      }

      return await response.json();
    } catch (error) {
      console.error('Mesaj alma hatası:', error);
      throw error;
    }
  },

  getConversations: async (userId: string): Promise<Conversation[]> => {
    try {
      const token = await getAuthToken();
      const response = await fetch(
        `${API_BASE_URL}/messages/conversations/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error('Konuşmalar alınamadı');
      }

      return await response.json();
    } catch (error) {
      console.error('Konuşma alma hatası:', error);
      throw error;
    }
  },

  markMessagesAsRead: async (
    senderId: string,
    receiverId: string
  ): Promise<{ success: boolean }> => {
    try {
      const token = await getAuthToken();
      const response = await fetch(
        `${API_BASE_URL}/messages/mark-read/${senderId}/${receiverId}`,
        {
          method: 'PUT',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error('Mesajlar okundu olarak işaretlenemedi');
      }

      return await response.json();
    } catch (error) {
      console.error('Mesaj okundu işaretleme hatası:', error);
      throw error;
    }
  },
};
